import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CnafPopupModalComponent } from '@cnaf/cnaf-commons-mon-compte-appli';
import { CnafAtTagService, CnafUserService } from '@cnaf/ng-cnaf-commons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { routesName } from '../app-routing.module';
import { LIBELLE_STAT } from '../constants/configlibelles';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { TagXitiService } from '../services/tagxiti.service';

declare function displayPopupGeoloc(reload: boolean): any;

@Component({
  template: ''
})
export abstract class ContacterMaCafCompletSharedComponent implements OnInit {
  @ViewChild('componentTemplate') componentTemplate!: TemplateRef<any>;

  profilMayotte!: boolean;
  profilEnfantsAutresPersonnes!: boolean;
  profilConjointsNonRadies!: boolean;
  profilUsagersPrimo!: boolean;
  profilTuteur!: boolean;
  profilAmi!: boolean;
  profilTutelle4!: boolean;
  profilTuteurAutresTutelles!: boolean;
  codeOrgaContact!: string;
  etat: string;
  presencePriseRendezVous: boolean;
  ouvertureNouvelleFenetrePourPriseRendezVous: boolean;
  isNational: boolean;
  annulationRDV: string;
  pageRdv: string;
  logged: boolean;
  pagePointsAccueil: string;
  afficheSectionPointAccueil: boolean;
  horaire: string;
  horaireEtudiant: string; 
  nom: string;
  adrsComp: string;
  voie: string;
  cp: string;
  banner: string;
  autorisationCourriel: boolean;
  geolocalise: boolean;
  isCafPilote: boolean;
  btnRdvName: string;
  isNotLoggedCafPilote: boolean;
  constructor(
    @Inject(String) readonly contexte: string,
    protected readonly cnafContacterMaCafService: CnafContacterMaCafService,
    protected readonly cnafUserService: CnafUserService,
    protected readonly modalService: BsModalService,
    protected readonly cnafAtTagService: CnafAtTagService,
    protected readonly router: Router,
    protected readonly tagXitiService: TagXitiService) {
    this.etat = 'loading';
    this.logged = false;
    this.ouvertureNouvelleFenetrePourPriseRendezVous = false;
    this.isNational = false;
    this.annulationRDV = '';
    this.pageRdv = '';
    this.pagePointsAccueil = '';
    this.afficheSectionPointAccueil = false;
    this.horaire = '';
    this.horaireEtudiant = '';
    this.nom = '';
    this.adrsComp = '';
    this.voie = '';
    this.cp = '';
    this.banner = '';
    this.autorisationCourriel = false;
    this.presencePriseRendezVous = false;
    this.geolocalise = false;
    this.isCafPilote = false;
    this.btnRdvName = '';
    this.isNotLoggedCafPilote = false;
  }

  ngOnInit(): void {
    this.onInit();

    if (this.cnafContacterMaCafService.processTypeActionSpecifiqueFromUrlParams) {
      const paramTypeActionSpecifique = this.cnafContacterMaCafService.getUrlParams()?.typeActionSpecifique;
      if (paramTypeActionSpecifique) {
        this.cnafContacterMaCafService.processTypeActionSpecifiqueFromUrlParams = false;
        this.cnafContacterMaCafService.actionLien(paramTypeActionSpecifique);
      }
    }

    this.recuperationProfils();

    if (this.codeOrgaContact === undefined || this.codeOrgaContact === '') {
      displayPopupGeoloc(true);
      this.geolocalise = false;
      this.etat = 'loaded';
    } else {
      this.geolocalise = true;
      this.logged = this.cnafContacterMaCafService.logged;
      const paramsUrl = this.cnafContacterMaCafService.getUrlParams();

      this.redirectPourRouteContactcafcourriel(paramsUrl);
      this.accesAuxPagesSelonProfil();
      const tagObj = this.tagXitiService.getAtTagObject('contactcaf', this.contexte, 'contactermacaf', '', '');
      this.cnafAtTagService.pageSend(tagObj);
    }
  }


  private redirectPourRouteContactcafcourriel(paramsUrl: any) {

    if (paramsUrl.paramRoutage === routesName.routeContactcafcourriel) {
      // suppression du paramRoutage dans l'url
      let tmpUrl = this.cnafContacterMaCafService.removeUrlParams(this.cnafContacterMaCafService.getWindowLocationHref(),
        this.cnafContacterMaCafService.getWindowLocationSearch(), ['paramRoutage']);
      // suppression de la route courante
      const routeCourante = (`#/${routesName.routeContactcaf}`);
      if (tmpUrl) {
        const indexRoute = tmpUrl.lastIndexOf(routeCourante);
        if (indexRoute !== -1) {
          tmpUrl = tmpUrl.substring(0, indexRoute);
        }
      }
      if (this.logged && !this.profilConjointsNonRadies) {
        if (this.profilEnfantsAutresPersonnes || this.profilUsagersPrimo) {
          return this.cnafContacterMaCafService.goToPage(`${tmpUrl}#/${routesName.routeContactcafprimocourriel}`);
        } else {
          return this.cnafContacterMaCafService.goToPage(`${tmpUrl}#/${routesName.routeContactcafcourriel}`);
        }
      }
      else {
        return this.cnafContacterMaCafService.goToPage(`${tmpUrl}#/${routesName.routeContactcaf}`);
      }
    }
  }

  private accesAuxPagesSelonProfil() {
    if (this.profilUsagersPrimo || this.profilAmi || !this.logged) {
      const params = { codeOrga: this.codeOrgaContact };
      this.getCourrielAutoriseNonAuth(params);
      this.getPagesLocalesNonAuth(params);
    }
    else if (!this.profilEnfantsAutresPersonnes) {
      if (this.profilConjointsNonRadies || this.profilTutelle4) {
        this.autorisationCourriel = false;
      } else {
        this.getCourrielAutorise();
      }
      this.getPagesLocales();
    } else {
      this.getCodeOrganismePersonne();
    }
  }

  private recuperationProfils() {
    this.profilMayotte = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_MAYOTTE);
    this.profilEnfantsAutresPersonnes = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ENFANTS_AUTRES_PERSONNES);
    this.profilConjointsNonRadies = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_CONJOINTS)
      && !this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_RADIES);
    this.profilUsagersPrimo = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_USAGERS_PRIMO);
    this.profilAmi = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AMI);
    this.codeOrgaContact = this.cnafContacterMaCafService.getCodeOrgaContact(this.profilAmi, this.profilUsagersPrimo);
    this.profilTuteur = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_TUTEUR_PHYSIQUE)
      || this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_TUTEUR_MORAL);
    this.profilTutelle4 = (this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_TUTELLE4)
      && (!this.profilTuteur));
    this.profilTuteurAutresTutelles =
      (this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AUTRES_TUTELLES)
        && (this.profilTuteur));
  }

  abstract onInit(): void;

  getCourrielAutoriseNonAuth(params: any): void {
    this.cnafContacterMaCafService.getCourrielAutoriseNonAuth(params).subscribe(
      {
        next: (data: any) => {
          this.getCourrielAutoriseOK(data);
        },
        error: () => {
        }
      }
    );
  }

  getCourrielAutorise(): void {

    this.cnafContacterMaCafService.getCourrielAutorise().subscribe(
      {
        next: (data: any) => {
          this.getCourrielAutoriseOK(data);
        },
        error: () => {
        }

      }
    );
  }

  getCourrielAutoriseOK(data: any): void {
    this.autorisationCourriel = data.courrielAutorise;
  }

  getCodeOrganismePersonne(): void {

    this.cnafContacterMaCafService.getCodeOrganismePersonne().subscribe(
      {
        next: (data: any) => {
          this.getCodeOrganismePersonneOk(data);
        },
        error: (error) => {
          this.getCodeOrganismePersonneKo(error);
        }

      }
    );
  }

  getCodeOrganismePersonneOk(data: any): void {
    const params = { codeOrga: data.codeOrganismePersonne };
    this.cnafContacterMaCafService.getCourrielAutoriseNonAuth(params).subscribe(
      {
        next: (datab: any) => {
          this.getCourrielAutoriseOK(datab);
        },
        error: () => {
        }

      }
    );
    this.cnafContacterMaCafService.getPagesLocalesNonAuth(params).subscribe(
      {
        next: (datab: any) => {
          this.getPagesLocalesOk(datab);
        },
        error: (error) => {
          this.etat = 'error';
        }

      }
    );

  }

  getPagesLocalesNonAuth(params: any): void {

    this.cnafContacterMaCafService.getPagesLocalesNonAuth(params).subscribe(
      {
        next: (data: any) => {
          this.getPagesLocalesOk(data);
        },
        error: (error) => {
          this.etat = 'error';
        }
      }
    );
  }

  getPagesLocales(): void {

    this.cnafContacterMaCafService.getPagesLocales().subscribe(
      {
        next: (data: any) => {
          this.getPagesLocalesOk(data);
        },
        error: (error) => {
          this.etat = 'error';
        }
      }
    );
  }

  getPagesLocalesOk(data: any): void {
    this.etat = 'loaded';
    this.banner = data.banner;
    this.ouvertureNouvelleFenetrePourPriseRendezVous = data.ouvertureNouvelleFenetrePourPriseRendezVous;
    this.isNational = data.national;
    this.annulationRDV = '';

    // Appel à "accesservicemiddle" pour savoir si on est sur une CAF pilote
    this.cnafContacterMaCafService.getAccessRdvTroov("priseRdv", this.codeOrgaContact).subscribe(
      (resultat: boolean) => {
        this.isCafPilote = resultat;
        // Cas des caf pilote prise de RDV (Troov)
        if (this.isCafPilote) {
          this.casCafPilotes();
        }
        // Cas Orion (A nettoyer après généralisation nouveau prestataire)
        else {
          this.casOrion(data);
        }

        if ((!this.isCafPilote && (this.profilConjointsNonRadies || this.profilAmi || this.profilTutelle4))
          //La prise de rendez-vous est fermée pour les AMI, les tuteurs et les protegés 4 dans une CAF pilote
            || (this.isCafPilote && (this.profilTuteur || this.profilTutelle4 || this.profilAmi))) {
          this.presencePriseRendezVous = false;
        }
        else if(this.isCafPilote){
          this.presencePriseRendezVous = true;
        }
        else {
          this.presencePriseRendezVous = data.presencePriseRendezVous;
        }

        // Gestion appli mobile
        this.gestionAppliMobile();

        if (data.pointsAccueil.indexOf('http') !== -1) {
          this.pagePointsAccueil = data.pointsAccueil;
        }

        this.afficheSectionPointAccueil = (!this.profilAmi && !this.profilTutelle4) && (data.presencePointsAccueil === true);

        // Données InfosCaf
        this.horaire = data.horaire_tel;
        this.horaireEtudiant = data.heureHiver ? "9h à 18h30" : "9h à 19h30" ;
        this.nom = data.caf_nom.toUpperCase().replace('CAISSE D\'ALLOCATIONS FAMILIALES', 'CAF');
        this.cnafContacterMaCafService.setNomCaf(this.nom);
        this.adrsComp = data.courrier.adrs_compl === null ? '' : data.courrier.adrs_compl;
        this.voie = `${(data.courrier.adrs_num_voie === null ? '' : data.courrier.adrs_num_voie)} ${(data.courrier.adrs_voie === null ? '' : data.courrier.adrs_voie)}`;
        this.cp = `${(data.courrier.adrs_cp === null ? '' : data.courrier.adrs_cp)} ${(data.courrier.adrs_commune_cedex === null ? '' : data.courrier.adrs_commune_cedex)}`;
      }
    );
  }

  private misEnPlaceConditionPriseRdv(data: any) {
    if ((!this.isCafPilote && (this.profilConjointsNonRadies || this.profilAmi || this.profilTutelle4))
      //La prise de rendez-vous est fermée pour les tuteurs dans une CAF pilote
      || (this.isCafPilote && this.profilTuteur)) {
      this.presencePriseRendezVous = false;
    } else {
      this.presencePriseRendezVous = data.presencePriseRendezVous;
    }
  }

  private gestionAppliMobile() {
    if (this.contexte === 'mobile') {
      let cookieAppVersion = this.cnafContacterMaCafService.getCookieByName('appVersion');
      if (typeof cookieAppVersion !== 'undefined' && cookieAppVersion.length > 0) {
        cookieAppVersion = cookieAppVersion.replace(/\./g, '-');
        // Pour pouvoir comparer les versions, on transforme celle-ci en nombre (exemple 2.2.0 devient 220)
        // si la version est supérieure ou égale à 2.5.0 (250), alors on intègre la page de prise de rdv dans l'applimobile
        if (parseInt(cookieAppVersion.split('-').join(''), 10) >= 250) {
          this.pageRdv = this.pageRdv?.replace('page=monCompte', 'page=applimobileMonCompte');
          this.annulationRDV = this.annulationRDV?.replace('page=monCompte', 'page=applimobileMonCompte');
        }
      }
    }
  }

  private casCafPilotes() {
    if (!this.logged) {
      this.isNotLoggedCafPilote = true;
    }
    this.pageRdv = '/redirect/s/Redirect?page=monComptePrendreUnRendezVousTroov';
    this.annulationRDV = '/redirect/s/Redirect?page=monCompteMonAgenda';
    this.btnRdvName = 'Prendre rendez-vous';
  }

  private casOrion(data: any) {
    this.pageRdv = data.priseDeRdv;
    if (!this.logged) {
      this.annulationRDV = '/redirect/s/Redirect?page=maCafAnnulerUnRendezVous';
    } else {
      this.annulationRDV = '/redirect/s/Redirect?page=monCompteAnnulerUnRendezVous';
    }
    this.btnRdvName = 'Demander un rendez-vous';
  }

  getCodeOrganismePersonneKo(error: any): void {
    this.etat = 'error';
  }

  displayPopupGeolocTs(reload: boolean): void {
    displayPopupGeoloc(reload);
  }

  contactcafcourriel(): void {
    if (this.profilTuteurAutresTutelles) {
      this.displayPopupTuteur();
    } else {
      this.router.navigate(['contactcafcourriel']);
    }
  }

  clickDemanderRdv(): void {
    // tag xiti
    const clickInfo = this.tagXitiService.getAtClickObject(this.isCafPilote ? 'bouton_prendre_un_rendez_vous' : 'bouton_demander_un_rendez_vous',
      'action', this.codeOrgaContact, LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleSurRendezVous);
    this.cnafAtTagService.click(clickInfo);
    if (!this.logged) {
      if (!this.isCafPilote) {
        //Context Orion
        this.displayPopupIncitationConnexion('Demander un rendez-vous', this.pageRdv, '/redirect/s/Redirect?page=monComptePrendreUnRendezVous');
      } else {
        //Context troov
        window.location.href = this.cnafContacterMaCafService.getLienCreationCompte(this.pageRdv);
      }
    } else if (this.profilTuteurAutresTutelles && this.contexte !== 'mobile') {
      this.displayPopupTuteur();
    } else {
      this.cnafContacterMaCafService.goToPage(this.pageRdv);
    }
  }

  clickAnnulerRdv(): void {
    // tag xiti
    const clickInfo = this.tagXitiService.getAtClickObject(this.isCafPilote ? 'bouton_annuler_ou_modifier_un_rendez_vous' : 'bouton_annuler_un_rendez_vous'
      , 'action', this.codeOrgaContact, LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleSurRendezVous);
    this.cnafAtTagService.click(clickInfo);
    if (this.profilTuteurAutresTutelles && this.contexte !== 'mobile') {
      this.displayPopupTuteur();
    } else {
      this.cnafContacterMaCafService.goToPage(this.annulationRDV);
    }
  }

  displayPopupIncitationConnexion(titre: string, lienNonConnecte: string, lienConnecte: string): void {
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-cnaf modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: titre,
        textBtnLeft: 'Je ne suis pas allocataire',
        textBtnRight: 'Je suis allocataire et je m\'identifie',
        content: ''
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      if (reason === 'btnLeft') {
        window.location.href = lienNonConnecte;
      }
      else if (reason === 'btnRight') {
        window.location.href = lienConnecte;
      }
      subscription.unsubscribe();
    });
  }


  displayPopupTuteur(): void {
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-fade',
      initialState: {
        title: 'Information',
        content: '<p>Cette action ne peut être réalisée que par l’allocataire.</p>',
        textBtnRight: 'Fermer'
      },
      ariaLabelledBy: 'titlePopupModal'
    });
  }
}
